// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__188QZ","add":"Footer_add__1Z9Zo","home":"Footer_home__1vCx_"};